<template>
    <div class="shop-page">
        <!-- 返回、标题 -->
        <div
            class="shop-page-header"
            :style="{ paddingTop: 25 + statusBarHeight + 'px' }"
        >
            <span class="shop-page-header-label">Yuliverse Clip System</span>
            <div class="shop-page-header-avatar" @click="changePhotoMode">
                <img :src="require('@/assets/images/YuliApp/CyberportCoupon/shop/avatar.png')">
            </div>
        </div>
        <!-- 主要内容区域 -->
        <div class="shop-page-content">
            <!-- 未启用相机情况 -->
            <div class="shop-page-content-unenable" v-show="!isUsePhoto">
                <div class="shop-page-content-unenable-code">
                    <img :src="require('@/assets/images/YuliApp/CyberportCoupon/shop/er_code.png')">
                </div>
                <div class="shop-page-content-unenable-label">CoffeeDAO</div>
                <div class="shop-page-content-unenable-button" @click.stop="enablePhotoHandle">Clip Coupon</div>
            </div>
            <!-- 启用相机情况 -->
            <div class="shop-page-content-enable" v-show="isUsePhoto">
                <video id="video" autoplay></video>
                <canvas id="canvas" style="display: none;"></canvas>
                <!-- 辅助框 -->
                <div class="shop-page-content-enable-frame">
                    <img :src="require('@/assets/images/YuliApp/CyberportCoupon/shop/code_frame.png')">
                    <div class="shop-page-content-enable-frame-line"></div>
                </div>
                <!-- tipsBox -->
                <div class="shop-page-content-enable-tipsBox"
                     :style="{
                        color: useTips.type == 'fail' ? '#C74B4B' : ''
                     }">
                    {{ useTips.text }}
                </div>
            </div>
        </div>
        <!-- 尾部 -->
        <div class="shop-page-foot">- Support by Yuliverse -</div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, nextTick, getCurrentInstance, onBeforeUnmount  } from "vue";
import { useRoute } from 'vue-router';
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import jsQR from "jsqr";
import { postUseTicket } from "@/api/cyberport.js"
import { ERROR_TEXT } from "@/constants/enums";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

export default {
props: {
    listData: {
        type: Array,
        default: () => {
            return []
        },
    },
},
watch: {

},
computed: {
    ...mapState({
        init: (state) => state.global.init,
        statusBarHeight: (state) => state.global.statusBarHeight,
    }),
},
setup(props, ctx) {
    const {listData} = props;
    const { proxy } = getCurrentInstance();
    const showList = ref([]);
    const isUsePhoto = ref(false); // 相机是否启用
    const videoRef = ref(null);
    const streamRef = ref(null);
    const usePhotoMode = ref('environment');
    const cdQrCodeLock = ref(false); // 验证冷却锁

    const tipsBox = ref({
        success: (id) => `Coupon #${id} Clip Success!`,
        fail: (id) => `Coupon clip failed, please try again later`,
        used: (id) => `Coupon #${id} has been clipped`,
    })

    const useTips = ref({
        text: '',
        type: null
    });

    onMounted(() => {
        appBridging.getStatusBarHeight();
        showList.value = listData?.filter(item => item?.isClip);
        videoRef.value = document.getElementById("video");
    });

    onBeforeUnmount(()=>{
        closeCamera();
    })

    const closeCamera = () => {
        if(streamRef.value){
            streamRef.value?.getTracks().forEach(track => track.stop());
        }
        isUsePhoto.value = false;
    }

    /**
     * 启用摄像头-按钮事件处理
     */
    const enablePhotoHandle = async (msg) => {
        proxy.$loading.show();
        await startCamera();
        proxy.$loading.hide();
    }

    const changePhotoMode = () => {
        // const useMode = usePhotoMode.value;
        // if(useMode == 'environment'){
        //     usePhotoMode.value = 'user';
        // }else{
        //     usePhotoMode.value = 'environment';
        // }
    }

    async function startCamera() {
        const video = document.getElementById('video');
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: {
                facingMode: usePhotoMode.value, // 调用后置， 前置-user
                width: { ideal: 720 },
                height: { ideal: 720 },
            } });
            streamRef.value = stream;
            video.srcObject = stream;
            video.onloadedmetadata = () => {
                video.play();
                setupCanvas(video); // 设置 Canvas 元素来捕获视频帧
            };
        } catch (error) {
            console.error('Error accessing camera:', error);
            proxy.$toast.show({
              msg: 'Error Accessing Camera',
              type: TOAST_TYPE.ERROR,
            });
            proxy.$loading.hide();
        }
    }

    function setupCanvas(video) {
        const canvas = document.getElementById('canvas');
        const context = canvas.getContext('2d');
        // canvas.width = video.videoWidth;
        // canvas.height = video.videoHeight;
        console.log('video.videoWidth: ', video.videoWidth);
        console.log('video.videoHeight: ', video.videoHeight);
        console.log('canvas.width: ', canvas.width);
        console.log('canvas.height: ', canvas.height);
        isUsePhoto.value = true;
        async function drawFrame() {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const qrcodeRes = jsQR(imageData.data, canvas.width, canvas.height, {
                inversionAttempts: "dontInvert", // 尝试关闭反转，以减少处理复杂性
            });
            console.log("QR Code detected:", qrcodeRes);
            if(qrcodeRes){
                // 检测是否在冷却时间
                if(!cdQrCodeLock.value){
                    // 扫码成功
                    cdQrCodeLock.value = true;
                    const { data } = qrcodeRes;
                    const params = JSON.parse(data);
                    proxy.$loading.show();
                    try {
                        const id = params.id + ''
                        const res = await postUseTicket(id, {
                            id: id,
                            value: params.code
                        });
                        console.log('res: ', res);
                        useTips.value = {
                            text: tipsBox.value.success(params.id),
                            type: 'success'
                        };
                    } catch (error) {
                        const code = error.response.data.code;
                        if(code == '400005'){
                            // 已使用
                            useTips.value = {
                                text: tipsBox.value.used(params.id),
                                type: 'fail'
                            };
                        }else{
                            // 其他报错
                            useTips.value = {
                                text: tipsBox.value.fail(params.id),
                                type: 'fail'
                            };
                        }
                        console.log(error);
                    }
                    proxy.$loading.hide();
                    setTimeout(()=>{
                        useTips.value = {
                            text: '',
                            type: 'null'
                        };
                        cdQrCodeLock.value = false;
                        closeCamera();
                    }, 1500)
                }
            }
            requestAnimationFrame(drawFrame);
        }

        video.addEventListener('play', () => {
            requestAnimationFrame(drawFrame);
        });
    }
    
    /**
     * 处理关闭
     */
     const handleClose = () => {
      ctx.emit("msgHandle", false);
    };

    return {
        handleClose,
        enablePhotoHandle,
        changePhotoMode,
        showList,
        isUsePhoto,
        useTips,
    };
},
};
</script>

<style lang="less">
    .shop-page{
        width: 100%;
        height: 100vh;
        background: radial-gradient(242.5% 50% at 50% 49.7%, #263046 0%, #182030 100%);;
        background-size: 100% 100%;
        position: relative;
        overflow-x: hidden;
        &-header {
            position: relative;
            width: 100%;
            height: 45px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            box-sizing: border-box;
            &-label{
                color: #ffffff;
                font-size: 16px;
                font-weight: 500;
                font-family: "PingFang SC";
                text-align: center;
            }
            &-avatar{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        &-content{
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            &-unenable{
                width: 233px;
                height: 267px;
                background: url("~@/assets/images/YuliApp/CyberportCoupon/shop/code_bg.png")
                no-repeat top left;
                background-size: 100% 100%;
                position: relative;
                padding: 29px 49px 0;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                align-items: center;
                &-button{
                    width: 142px;
                    height: 39px;
                    border-radius: 31px;
                    background: #5c62ef;
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 500;
                    font-family: "PingFang SC";
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: -65px;
                    left: 50%;
                    transform: translate(-50%, 0);
                }
                &-button2{
                    width: 144px;
                    height: 39px;
                    border-radius: 31px;
                    background: #5c62ef;
                    color: #ffffff;
                    font-size: 16px;
                    font-weight: 500;
                    font-family: "PingFang SC";
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: absolute;
                    bottom: -125px;
                    left: 50%;
                    transform: translate(-50%, 0);
                }
                &-code{
                    width: 135px;
                    height: 128px;
                    margin-bottom: 65px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                &-label{
                    white-space: nowrap;
                    color: #070606;
                    font-size: 14px;
                    font-weight: 500;
                    font-family: "PingFang SC";
                    text-align: center;
                }
            }
            &-enable{
                width: 210px;
                height: 210px;
                position: relative;
                box-sizing: border-box;
                &-frame{
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 210px;
                    height: 210px;
                    z-index: 10;
                    &-line{
                        width: 100%;
                        height: 46px;
                        background: url("~@/assets/images/YuliApp/CyberportCoupon/shop/code_frame_line.png")
                        no-repeat top left;
                        background-size: 100% 100%;
                        position: absolute;
                        top: 0;
                        left: 0;
                        animation: toDown 2s linear infinite;
                        transition: all .1s;
                        @keyframes toDown {
                            0% {
                                top: 0;
                            }
                            100% {
                                top: calc(210px - 46px);
                            }
                        }
                    }
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                &-tipsBox{
                    position: absolute;
                    top: -54px;
                    left: 50%;
                    transform: translateX(-50%);
                    width: 150%;
                    box-sizing: border-box;
                    height: 44px;
                    display: flex;
                    align-items: flex-start;
                    justify-content: center;
                    color: #4bc78b;
                    font-size: 18px;
                    font-weight: 500;
                    font-family: "PingFang SC";
                    text-align: center;
                    white-space: nowrap;
                }
            }
        }
        &-foot{
            position: absolute;
            bottom: 23px;
            left: 50%;
            transform: translateX(-50%);
            color: #ffffff;
            font-size: 15px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
            line-height: 18px;
        }
        #video{
            width: 210px;
            height: 210px;
            object-fit: cover;
        }
        #canvas{
            width: 210px;
            height: 210px;
        }
    }
</style>